<template>
  <div class="filter-button-group-size-wrapper">
    <b-dropdown
      class="search-types-dropdown group-size-dropdown"
      :ref="section.filter"
      no-caret
    >
      <template #button-content>
        <span class="d-sm-inline">
          {{ buttonLabel }}
        </span>
        <font-awesome-icon class="right-icon group-size-dropdown--chevron" :icon="['far', 'chevron-down']"/>
      </template>
      <b-dropdown-item-button
        v-for="(option, optionIndex) in section.options"
        :key="optionIndex"
        class="group-size-dropdown--button"
        :active="filterSelected(section.filter, option.value)"
        @click="selectTag(option)"
      >
        {{ option.label }}
      </b-dropdown-item-button>
    </b-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { includes } from 'lodash'

export default {
  name: 'FilterButtonGroupSize',

  props: {
    section: Object,
  },

  data: () => ({
    localOptionValue: null,
  }),

  computed: {
    ...mapGetters('filter', [
      'filterSelected',
      'sectionFilterSelected',
    ]),

    buttonLabel() {
      return this.localOptionValue || this.section.label
    },

    currentlySelected() {
      return this.section.options.find((option) => this.sectionFilterSelected(this.section.filter) === option.value)
    },
  },

  created() {
    this.localOptionValue = this.currentlySelected?.label
  },

  methods: {
    ...mapActions('filter', [
      'addFilter',
    ]),

    async selectTag(option) {
      if (option.label === this.localOptionValue) {
        this.localOptionValue = null
      } else {
        this.localOptionValue = option.label
      }

      let localOptionValue = option.value

      if (includes(['checkbox', 'buttons'], this.section.display_type)) {
        localOptionValue = [option.value]
      }
      await this.addFilter({ filter: this.section.filter, type: this.section.display_type, options: localOptionValue })
    },
  },
}
</script>

<style lang="scss">
.filter-button-group-size-wrapper {
  .group-size-dropdown {
    position: initial;
    margin-right: 0.5rem;
    overflow: hidden;

    > button {
      background-color: $color-yellow-lighter;
      border-radius: 4px;
      border: 1px solid rgba(28, 36, 51, 0.20);
    }

    &.show {
      > .btn-secondary.dropdown-toggle {
        color: inherit !important;
        background-color: $color-yellow-light;
        border: 1px solid rgba(28, 36, 51, 0.20);
      }
    }

    > ul {
      top: 26px !important;
    }

    &--chevron {
      font-size: 12px;
    }
  }
}
</style>
